import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosClient from '@/lib/auth';
import { useAuthStore } from '@/store/authStore';
import { FetchAlertQuery } from '@/lib/api/monitoring/alert';

interface CreateNoteParams {
  note: string;
  nonActioningNote?: boolean;
}


export const useCreateAlertNote = (alertData: {
  companyId: string;
  projectId: string;
  alertId: string;
}) => {
  const { user } = useAuthStore();
  const userFullName = `${user?.firstName} ${user?.lastName}`;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ note, nonActioningNote = false }: CreateNoteParams) => {
      if (!alertData?.alertId || !alertData.companyId || !alertData.projectId) {
        return () => {
          console.log('Missing alert information to create note');
        };
      }

      return axiosClient.post(
        `/company/${alertData.companyId}/project/${alertData.projectId}/Monitoring/alerts/${alertData.alertId}/note`,
        {
          author: userFullName,
          nonActioningNote,
          note,
        }
      );
    },
    onSuccess: () => {
      if (alertData?.alertId) {
        queryClient.invalidateQueries({
          queryKey: FetchAlertQuery(alertData.alertId).queryKey,
        });
      }
    },
  });
};
